<template>
  <md-toolbar id="toolbar" md-elevation="0" class="md-white md-absolute no-print">
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <a href="/#/">
          <h3 class="md-title">The Barkers</h3>
        </a>
        <md-field v-if="!$route.params.id">
          <label>Search recipes...</label>
          <md-input v-model="RecipeListState.searchText" style="width: 8rem"></md-input>
        </md-field>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{toggled: toggledClass}"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="true"></mobile-menu>
            <md-list>
              <li class="md-list-item" v-if="!$route.params.id">
                <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button slot="title" class="md-button md-button-link md-white md-simple " data-toggle="dropdown">
                        <p>Sorting</p>
                      </md-button>
                      <ul class="dropdown-menu dropdown-with-icons">
                        <li>
                          <a href="#" @click="sortSelect('timeMins', $event)" :style="{backgroundColor: !timeSort ? 'white':'darkcyan'}">
                            <i v-if="!timeSort" class="material-icons">access_time</i>
                            <md-icon v-if="timeSort">check</md-icon>
                            <p>Time to Make</p>
                          </a>
                        </li>
                        <li>
                          <a href="#" @click="sortSelect('created', $event)" :style="{backgroundColor: !dateSort ? 'white':'darkcyan'}">
                            <i v-if="!dateSort" class="material-icons">calendar_today</i>
                            <md-icon v-if="dateSort">check</md-icon>
                            <p>Date Added</p>
                          </a>
                        </li>
                        <li>
                          <a href="#" @click="sortSelect('rating', $event)" :style="{backgroundColor: !ratingSort ? 'white':'darkcyan'}">
                            <i v-if="!ratingSort" class="material-icons">star</i>
                            <md-icon v-if="ratingSort">check</md-icon>
                            <p>Rating</p>
                          </a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
              </li>
              <li class="md-list-item">
                <a href="/#/" class="md-list-item-router md-list-item-container md-button-clean">
                  <div class="md-list-item-content">
                    <md-button slot="title" class="md-button md-button-link md-white md-simple">
                      <i class="material-icons">home</i>
                      <p>Main</p>
                    </md-button>
                  </div>
                </a>
              </li>
              <li class="md-list-item" v-if="$route.params.id">
                <a
                  href="/#/recipes"
                  class="md-list-item-router md-list-item-container md-button-clean"
                >
                  <div class="md-list-item-content">
                    <md-button slot="title" class="md-button md-button-link md-white md-simple">
                      <i class="material-icons">restaurant_menu</i>
                      <p>Recipes</p>
                    </md-button>
                  </div>
                </a>
              </li>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    }
  },
  data() {
    return {
      toggledClass: false,
      timeSort: false,
      dateSort: false,
      ratingSort: false
    };
  },
  created () {
    this.NavbarStore.showNavbar = false;
  },
  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    sortSelect(which, event) {
      if (this.RecipeListState.sorting.length > 0 && which === this.RecipeListState.sorting[0]) {
        this.RecipeListState.sorting = [];
      } else {
        this.RecipeListState.sorting = [which];
      }
      this.timeSort = this.RecipeListState.sorting.length > 0 && this.RecipeListState.sorting[0] === 'timeMins';
      this.dateSort = this.RecipeListState.sorting.length > 0 && this.RecipeListState.sorting[0] === 'created';
      this.ratingSort = this.RecipeListState.sorting.length > 0 && this.RecipeListState.sorting[0] === 'rating';
      if (this.toggledClass) {
        this.toggleNavbarMobile();
      }
      event.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
@media print {
  .no-print {
    display: none;
  }
}

.sort-selected {
  background-color: darkcyan;
}
</style>
